import axios from "axios";

export const state = {
    reportloanperusers: [],
};

export const getters = {
    reportloanperusers: state => state.reportloanperusers,
};

export const mutations = {
    setReportLoansPerUser(reportloanperusers, newValue) { state.reportloanperusers = newValue},
};

export const actions = {
    async fetchReportLoansPerUser({ commit }) {
        await axios.get('/reportloanperusers').then(res => {
            commit('setReportLoansPerUser', res.data.loans)
        })
    },
    async filterReportLoansPerUser({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportloanperusers";
        await axios.post(url, formData).then((response) => {
            commit('setReportLoansPerUser', response.data.loans)
        })
    },
};
